/* run_audit.icon.svg.js */

module.exports = {
    icon: `    
            <svg viewBox="0 0 22 20" preserveAspectRatio="none">
            <path class="foreground-gl" d="M16.56,2.54H14.25a3.48,3.48,0,0,0-6.66,0H5.19A1.87,1.87,0,0,0,3.32,4.41V18.59a1.87,1.87,0,0,0,1.87,1.87H16.56a1.87,1.87,0,0,0,1.87-1.87V4.41A1.87,1.87,0,0,0,16.56,2.54ZM8.69,3.7h.05V3.58a2.18,2.18,0,0,1,.62-1.51h0a2.31,2.31,0,0,1,.39-.31l.15-.08a2.07,2.07,0,0,1,.34-.15l.14,0a2.08,2.08,0,0,1,1.07,0l.12,0a2.65,2.65,0,0,1,.42.18l0,0a2.16,2.16,0,0,1,1,1.84V3.7H15.6c-.06.7-.17,2.17-1.62,2.2H7.79c-1.44,0-1.55-1.5-1.62-2.2Zm7.93,5.59-5.76,8a.86.86,0,0,1-.67.35h0a.85.85,0,0,1-.67-.32l-3.25-4a.86.86,0,0,1,1.34-1.07l2.54,3.15,5.1-7a.86.86,0,0,1,1.2-.19A.85.85,0,0,1,16.62,9.29Z"/>
            </svg>
         `
};
